"use client";

import { OspToast } from "@ospweb/sdk-ui";

import { EdgenModalCreateAble } from "@components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@components/EdgenModal/waitForEdgenModalRoot";

import { PortfolioAccountsModalContent } from "./PortfolioAccountsModal";
// import { portfolioAccountsModalShellProps } from "./portfolioAccountsModalShell";
import { IS_PLAID_OPEN } from "./openPlaidImportModal";
import type {
  OpenPortfolioAccountsModalParams,
  PlaidImportModalResult,
} from "./types";
import { plaidImportModalShellProps } from "./plaidImportModalShell";

let pendingPortfolioAccountsModal: Promise<PlaidImportModalResult> | null =
  null;

/** Portfolio scenario — bottom drawer (mobile) / centered 740px (PC). Requires existing connections. */
export const openPortfolioAccountsModal = (
  params: OpenPortfolioAccountsModalParams = {},
): Promise<PlaidImportModalResult> => {
  if (!IS_PLAID_OPEN) {
    OspToast.info({ content: "Coming soon, please choose other ways" });
    return Promise.resolve({ action: "close" });
  }

  if (pendingPortfolioAccountsModal) {
    return pendingPortfolioAccountsModal;
  }

  const { onBindSuccess, onAddAccount } = params;

  pendingPortfolioAccountsModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<PlaidImportModalResult>((resolve) => {
        let settled = false;
        let modalCall: Promise<boolean> | null = null;

        const finish = (result: PlaidImportModalResult) => {
          if (settled) {
            return;
          }
          settled = true;
          pendingPortfolioAccountsModal = null;
          if (modalCall) {
            EdgenModalCreateAble.end(modalCall, false);
          } else {
            EdgenModalCreateAble.end(false);
          }
          resolve(result);
        };

        modalCall = EdgenModalCreateAble.call({
          children: (
            <PortfolioAccountsModalContent
              onBindSuccess={onBindSuccess}
              onAddAccount={onAddAccount}
              onClose={finish}
              className="md:p-6"
              headerClassName="md:flex-row-reverse md:justify-between md:pt-0"
              iconBtnClassName="md:bg-transparent"
            />
          ),
          ...plaidImportModalShellProps(),
          maskClosable: false,
        });
      }),
  ).catch((error) => {
    pendingPortfolioAccountsModal = null;
    throw error;
  });

  return pendingPortfolioAccountsModal;
};
